import { styled } from "@mui/material";
import { DRAWER_WIDTH } from "../styles/sizes";

/**
 * Holds the main content of a page next to the drawer. Adds a margin when the adjacent drawer is open.
 */
const DrawerMain = styled("main", {
  shouldForwardProp: (prop) => prop !== "open",
})<{
  open?: boolean;
}>(({ theme, open }) => ({
  flexGrow: 1,
  padding: theme.spacing(3),
  transition: theme.transitions.create("margin", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginRight: `0px`,
  ...(open && {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: `${DRAWER_WIDTH}px`,
  }),
}));

export default DrawerMain;
